import { useState } from "react";

interface FilterBarProps {
  genres: string[];
  regions: string[];
  years: string[];
  genre: string;
  region: string;
  year: string;
  onGenre: (v: string) => void;
  onRegion: (v: string) => void;
  onYear: (v: string) => void;
  onReset: () => void;
}

function ChipRow({
  label,
  icon,
  options,
  value,
  onSelect,
}: {
  label: string;
  icon: string;
  options: string[];
  value: string;
  onSelect: (v: string) => void;
}) {
  return (
    <div className="flex items-start gap-3 border-b border-background-200 py-3 last:border-b-0">
      <span className="flex w-16 shrink-0 items-center gap-1 pt-1 text-xs font-medium text-foreground-500">
        <i className={`${icon} text-sm`} aria-hidden="true"></i>
        {label}
      </span>
      <div className="flex flex-wrap gap-2">
        {options.map((opt) => {
          const active = opt === value;
          return (
            <button
              key={opt}
              type="button"
              onClick={() => onSelect(opt)}
              className={`rounded-md px-3 py-1.5 text-xs transition-colors cursor-pointer ${
                active
                  ? "bg-primary-500 font-semibold text-background-50"
                  : "bg-background-100 text-foreground-600 hover:bg-primary-50 hover:text-primary-700"
              }`}
            >
              {opt}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default function FilterBar({
  genres,
  regions,
  years,
  genre,
  region,
  year,
  onGenre,
  onRegion,
  onYear,
  onReset,
}: FilterBarProps) {
  const [open, setOpen] = useState(false);
  const dirty = genre !== "全部" || region !== "全部" || year !== "全部";

  return (
    <div className="rounded-lg border border-background-200 bg-background-50">
      <div className="flex items-center justify-between px-4 py-3 lg:hidden">
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex items-center gap-2 text-sm font-medium text-foreground-800 cursor-pointer"
          aria-expanded={open}
        >
          <i className="ri-filter-3-line text-base" aria-hidden="true"></i>
          筛选条件
          {dirty && <span className="rounded-full bg-primary-500 px-1.5 text-[11px] text-background-50">已选</span>}
        </button>
        <i className={open ? "ri-arrow-up-s-line text-xl text-foreground-500" : "ri-arrow-down-s-line text-xl text-foreground-500"} aria-hidden="true"></i>
      </div>

      <div className={`${open ? "block" : "hidden"} px-4 pb-2 lg:block lg:px-5 lg:py-2`}>
        <ChipRow label="类型" icon="ri-price-tag-3-line" options={genres} value={genre} onSelect={onGenre} />
        <ChipRow label="地区" icon="ri-earth-line" options={regions} value={region} onSelect={onRegion} />
        <ChipRow label="年份" icon="ri-calendar-line" options={years} value={year} onSelect={onYear} />
        {dirty && (
          <div className="flex justify-end py-2">
            <button
              type="button"
              onClick={onReset}
              className="flex items-center gap-1 rounded-md border border-background-200 px-3 py-1.5 text-xs text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600 cursor-pointer"
            >
              <i className="ri-refresh-line" aria-hidden="true"></i>
              重置筛选
            </button>
          </div>
        )}
      </div>
    </div>
  );
}